import { ReactNode, createContext, useContext } from 'react';
import { Shift } from '@sdk/automatedBreaks/types/Shift';
import { TaskInstance } from '@sdk/shiftTasks/types/apiTypes';

import { AppStateType, User } from '@kiosk/common/types';

import { ClockedInViewContextType, TimeClockNoteRef } from './ClockedInViewProvider.types';

export const ClockedInViewContext = createContext<ClockedInViewContextType>(
  null as ClockedInViewContextType
);

type Props = {
  children: ReactNode;
  shift: Shift & { taskInstances?: TaskInstance[] };
  user: User;
  deviceHeight: number;
  usTimeFormat: boolean;
  signOut: VoidFunction;
  clockOut: VoidFunction;
  startBreak: VoidFunction;
  endBreak: VoidFunction;
  type: AppStateType;
  isIntegrationKiosk: boolean;
  appState: AppStateType;
  updateShift: (shift: Shift) => void;
  timeClockNoteRef: TimeClockNoteRef;
};

export const useClockedInViewContext = () => {
  const context = useContext(ClockedInViewContext);

  if (!context) {
    throw new Error('ClockedInViewContext must be used within a ClockedInViewProvider');
  }

  return context;
};

export const ClockedInViewProvider = ({ children, ...restProps }: Props) => {
  const value: ClockedInViewContextType = {
    ...restProps
  };

  return <ClockedInViewContext.Provider value={value}>{children}</ClockedInViewContext.Provider>;
};
